import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './role.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Role } from "model/system/role.model";

export interface RoleDetailsProps extends DetailsStateAndDispatchProps<Role>,
  RouteComponentProps, StateProps, DispatchProps {
}
const RoleDetails: FC<RoleDetailsProps> = (props) => {

  return (
    <DetailsPage<Role>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Role>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>
    </DetailsPage>);
};

const mapStateToProps = ({ role }: RootState) => ({
  entity: role.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(RoleDetails);
